// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3NrZr"};